import type { DocumentsFolderDetailsDto } from "@/api/types";
import { getOriginalTranslationValue } from "@/helpers/languages";

import type { CreateOrEditFolderFormValues } from "./DocumentFolderForm";

export function getDefaultFormValues(
  parentFolderId: string,
  folderDetails?: DocumentsFolderDetailsDto,
): CreateOrEditFolderFormValues {
  return {
    name: folderDetails
      ? getOriginalTranslationValue(folderDetails.nameTranslations, folderDetails.originalLanguageId)
      : "",
    parentFolderId: folderDetails ? folderDetails.parentFolderId : parentFolderId,
  };
}
